import { getSizeWithinBounds } from '@folklore/size';
import isString from 'lodash-es/isString';
import { useEffect, useRef, useState, ReactNode } from 'react';

import useElementSize from '../../hooks/useElementSize';

import styles from '../../styles/ads/parallax-ad.module.css';

export interface ParallaxAdProps {
    image?: string;
    imagePortrait?: string | null;
    imageSquare?: string | null;
    width?: number | null;
    height?: string | number | null;
    isFluid?: boolean;
    format?: 'cover' | 'contain' | 'centered';
    backgroundColor?: string | null;
    clickUrl?: string;
    children?: ReactNode;
}

function ParallaxAd({
    width = null,
    height = '50%',
    isFluid = false,
    image,
    imagePortrait = null,
    imageSquare = null,
    format = 'cover',
    backgroundColor = null,
    clickUrl,
}: ParallaxAdProps) {
    const imageRef = useRef(null);
    const [{ width: imageWidth, height: imageHeight }, setImageSize] = useState({
        width: 0,
        height: 0,
    });
    const { ref: containerRef, width: containerWidth } = useElementSize();
    const {
        ref: imageContainerRef,
        width: imageContainerWidth,
        height: imageContainerHeight,
    } = useElementSize();
    // const [imageStyle, setImageStyle] = useState({
    //     top: 0,
    //     left: 0,
    //     width: 0,
    //     height: 0,
    // });
    // useEffect(() => {
    //     function updateImageStyle() {
    //         const { innerWidth: windowWidth, innerHeight: windowHeight } = window;
    //         const { width: containerWidth } = containerRef.current.getBoundingClientRect();

    //     }
    //     updateImageStyle();
    //     window.addEventListener('resize', updateImageStyle);
    //     return () => {
    //         window.removeEventListener('resize', updateImageStyle);
    //     };
    // }, [format, imageWidth, imageHeight, imageContainerWidth, imageContainerHeight]);

    const {
        width: newWidth,
        height: newHeight,
        scale: newScale,
    } = getSizeWithinBounds(imageWidth, imageHeight, imageContainerWidth, imageContainerHeight, {
        cover: format === 'cover',
    });
    const imageStyle = {
        // width: newWidth,
        // height: newHeight,
        // top: (windowHeight - newHeight) / 2,
        // left: (windowWidth - newWidth) / 2,
        top: format === 'centered' && newScale >= 1 ? '50%' : null,
        left: format === 'centered' && newScale >= 1 ? '50%' : null,
        width: imageWidth,
        height: imageHeight,
        transform:
            format === 'centered' && newScale >= 1
                ? 'translate3d(-50%, -50%, 0)'
                : `translate3d(${(imageContainerWidth - newWidth) / 2}px, ${(imageContainerHeight - newHeight) / 2}px, 0px) scale(${newScale})`,
    };

    const onImageLoad = () => {
        setImageSize({
            width: imageRef.current.naturalWidth,
            height: imageRef.current.naturalHeight,
        });
    };
    useEffect(() => {
        setImageSize({
            width: imageRef.current.naturalWidth || 0,
            height: imageRef.current.naturalHeight || 0,
        });
    }, [setImageSize]);

    let finalHeight = imageContainerHeight * 0.5;
    if (isString(height) && height.match(/^([0-9]+)%$/) !== null) {
        const [, percentage] = height.match(/^([0-9]+)%$/);
        finalHeight = imageContainerHeight * (parseInt(percentage, 10) / 100);
    } else if (isString(height) && height.match(/^([0-9]+)(px)?$/) !== null) {
        const [, pixel] = height.match(/^([0-9]+)(px)?$/);
        finalHeight = parseInt(pixel, 10);
    }

    const ratio = imageContainerWidth / imageContainerHeight;
    let finalImage = image;
    if (imagePortrait !== null && imagePortrait.length > 0 && ratio < 0.8) {
        finalImage = imagePortrait;
    } else if (imageSquare !== null && imageSquare.length > 0 && ratio > 0.8 && ratio < 1.2) {
        finalImage = imageSquare;
    }

    return (
        <div
            className={styles.container}
            style={{
                width: isFluid ? '100%' : width,
                height: finalHeight,
            }}
            ref={containerRef}
        >
            <div className={styles.frame}>
                <div
                    className={styles.imageContainer}
                    style={{
                        width: containerWidth,
                        backgroundColor:
                            backgroundColor !== 'blur' ? backgroundColor : 'transparent',
                    }}
                    ref={imageContainerRef}
                >
                    {backgroundColor === 'blur' ? (
                        <div
                            className={styles.background}
                            style={{
                                backgroundImage: `url(${image})`,
                            }}
                        />
                    ) : null}
                    <a
                        href={clickUrl}
                        rel="noopener noreferrer"
                        target="_blank"
                        className={styles.link}
                    >
                        <img
                            src={finalImage}
                            alt="Ad"
                            className={styles.image}
                            width={imageWidth}
                            height={imageHeight}
                            ref={imageRef}
                            style={imageStyle}
                            onLoad={onImageLoad}
                        />
                    </a>
                </div>
            </div>
        </div>
    );
}

export default ParallaxAd;
